import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {removeNonDigits} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class GeneralRings extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            listType: 0,
            supplement: 0,
            fromClub: '',
            toClub: '998',
            year: String(new Date().getFullYear()),
        });
    }

    fields = [];

    render() {
        return <div className="general-rings">
            <div className={'upper-container'}>
                <div className={'column-gap left'}>
                    <div className={'attribute-pair'}>
                        <label>År</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 field60"
                            containerClassName="display-inline-block"
                            name="year"
                            id="year"
                            maxLength={4}
                            required={true}
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{4}`}]}
                            value={this.state.year}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[0].setState({focused: false, visited: true});
                                if (/^[0-9]{2}$/.test(this.state.year)) this.setState({year: '20' + this.state.year});
                            }}
                            ref={instance => { this.fields[0] = instance; }}
                        />
                    </div>
                    <span className="checkbox-span">
                        <input
                            id="only-supplement"
                            name="supplement"
                            type="checkbox"
                            checked={this.state.supplement}
                            onChange = {()=>{this.setState({supplement: this.state.supplement ? 0 : 1})}}
                        />
                        <label htmlFor="only-supplement">Kun supplerende</label>
                    </span>
                </div>
                {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className={'column-gap right'}>
                    <div className={'attribute-pair'}>
                        <label>Fra forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromClub"
                            id="fromClub"
                            maxLength={3}
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{3}`}]}
                            value={this.state.fromClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[1].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[1] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toClub"
                            id="toClub"
                            maxLength={3}
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{3}`}]}
                            value={this.state.toClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[2].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[2] = instance; }}
                        />
                    </div>
                </div>}
            </div>
            <div className={'lower-container'}>
                <div className={'radio-buttons-container column-gap'}>
                    <div className="radio-button-container">
                        <input id="reporting-list" type="radio" checked={this.state.listType === 0} onChange={() => this.setState({listType: 0})}/>
                        <label htmlFor="reporting-list">Liste til indberetning af ringnummertildeling</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="control-list" type="radio" checked={this.state.listType === 1} onChange={() => this.setState({listType: 1})}/>
                        <label htmlFor="control-list">Kontrolliste til fordeling af ringnumre</label>
                    </div>
                    <div className="radio-button-container">
                        <input id="ring-list" type="radio" checked={this.state.listType === 2} onChange={() => this.setState({listType: 2})}/>
                        <label htmlFor="ring-list">Ringliste til Brevduen</label>
                    </div>
                </div>
            </div>
        </div>
    }

    onDigitInputFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: removeNonDigits(e.target.value)});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        if (this.state.fromClub !== '' && this.state.toClub !== '' && this.state.fromClub > this.state.toClub) errors.push(`Fra forening kan ikke være større end Til forening.`);

        const options = {
            listType:   this.state.listType,
            supplement: this.state.supplement,
            fromClub:   this.state.fromClub === '' ? null : this.state.fromClub,
            toClub:     this.state.toClub   === '' ? null : this.state.toClub,
            year:       this.state.year     === '' ? null : this.state.year,
        }
        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(GeneralRings);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/GeneralRings.js